/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('DenyPendingRegistration', {
  Instructions: 'Your account is not fully setup and is unable to access the app.',
  LogOut: 'Log Out'
});
